import type { Action } from 'redux'
import type { Journey, JourneyRequest } from '../../../domain/models/journey'
import { LOGOUT } from '../../../../authentication/presentation/redux/types/log-out-types'
import * as types from '../types/journey-types'

export const InitialStateJourney = {
  journey: null as Journey | null,
  journeyUpdate: {} as Partial<JourneyRequest>,
  load: false,
  error: '',
  conclude: {
    loading: false,
    success: false,
  },
}

export const journeyReducer = (
  state = InitialStateJourney,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }
  switch (action.type) {
    case types.GET_JOURNEY_REQUEST:
    case types.CREATE_JOURNEY_REQUEST:
    case types.CONCLUDE_JOURNEY_REQUEST:
      newState.load = true
      newState.error = ''
      if (action.type === types.CONCLUDE_JOURNEY_REQUEST) {
        newState.conclude = { loading: true, success: false }
      }
      return newState

    case types.GET_JOURNEY_ERROR:
    case types.CREATE_JOURNEY_ERROR:
    case types.CONCLUDE_JOURNEY_ERROR:
      newState.load = false
      newState.error = action.payload
      if (action.type === types.CONCLUDE_JOURNEY_ERROR) {
        newState.conclude = { loading: false, success: false }
      }
      return newState

    case types.GET_JOURNEY_SUCCESS:
    case types.CREATE_JOURNEY_SUCCESS:
    case types.CONCLUDE_JOURNEY_SUCCESS:
      newState.load = false
      newState.error = ''
      if (action.type === types.CONCLUDE_JOURNEY_SUCCESS) {
        newState.conclude = { loading: false, success: true }
        // Manter os dados da journey existente para permitir impressão após conclusão
      } else {
        newState.journey = action.payload
      }
      return newState

    case types.JOURNEY_UPDATE:
      return {
        ...state,
        journeyUpdate: {
          ...state.journeyUpdate,
          ...action.payload,
        },
      }

    case types.JOURNEY_RESET:
      if (action.payload) {
        return InitialStateJourney
      } else {
        return {
          ...state,
          error: '',
          conclude: { ...state.conclude, loading: false },
        }
      }

    case LOGOUT:
      return InitialStateJourney

    default:
      return { ...state }
  }
}
